import * as R from 'ramda'


export const selectListingAlertReducer = state => state.listingAlert
export const selectSavedAlerts = R.compose(state => state.list, selectListingAlertReducer)
export const selectListingAlerts = R.compose(state => state.listing_alerts, selectSavedAlerts)
export const selectListingAlertsIsUpdating = R.compose(state => state.isUpdating, selectListingAlertReducer)
export const selectReComputingTags = R.compose(state => state.isReComputingTags, selectListingAlertReducer)
